'use client';

import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

/**
 * Provider de TanStack Query para toda la app.
 *
 * Por ahora solo lo usa el módulo Email (Fase 1: listado de Inbox), pero
 * queda disponible para cualquier otro módulo que en el futuro quiera
 * usar la misma librería para datos remotos con cache.
 */
export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30 * 1000, // 30s: evita refetch innecesario al volver a una pantalla
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      })
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
